// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__xHURt","modalFooterButton":"ModalNotes_modalFooterButton__3U6vq"};